
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { CalendarProvider } from "@/types/calendar";

interface CalendarIntegrationContentProps {
  isCheckingConnection: boolean;
  availableProviders: CalendarProvider[];
  isConnecting: boolean;
  currentUser: any;
  onShowProviderSelection: () => void;
}

const CalendarIntegrationContent = ({
  isCheckingConnection,
  availableProviders,
  isConnecting,
  currentUser,
  onShowProviderSelection
}: CalendarIntegrationContentProps) => {
  if (isCheckingConnection) {
    return (
      <div className="flex flex-col items-center gap-4">
        <div className="text-center text-muted-foreground">Checking connection status...</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Add Calendar Button - always show if user is authenticated */}
      {currentUser && (
        <Button 
          className="w-64 flex gap-2 items-center justify-center bg-primary hover:bg-primary/90 text-primary-foreground" 
          onClick={onShowProviderSelection}
          disabled={isConnecting}
        >
          <Plus className="h-4 w-4" />
          {isConnecting ? "Connecting..." : "Add Calendar"}
        </Button>
      )}
      
      {!currentUser && (
        <p className="text-sm text-amber-600">
          Please sign in to connect your calendar
        </p>
      )}
      
      <div className="mt-12 border-t border-border pt-6 w-full">
        <h3 className="font-medium mb-2 text-foreground">What you can do with Calendar Integration:</h3>
        <ul className="list-disc list-inside space-y-2 text-muted-foreground">
          <li>Receive reminders about important events</li>
          <li>Schedule meetings using voice or chat</li>
          <li>Get notified about upcoming appointments</li>
          <li>Manage your schedule with voice commands</li>
          <li>Support for both Google Calendar and Outlook Calendar</li>
          <li>Connect multiple accounts from the same provider</li>
        </ul>
      </div>
    </div>
  );
};

export default CalendarIntegrationContent;
